<template>
  <main class="view-register remove-body-top-padding d-flex flex-column">
    <article class="d-flex flex-md-row">
      <section itemscope itemtype="http://schema.org/RegisterAction" class="register-form d-block col-lg-5 col-md-6 col-xxs-12 h-100 min-vh-100 overflow-auto bg-white px-xxs-2 px-sm-3 px-md-4 px-lg-5 pt-5">
        <RegisterForm />
        <RegisterByGoogle />
        <div class="d-flex justify-content-end px-5 d-xxs-none d-sm-flex d-md-none">
          <b-img :src="portalGeneralInfo.logoWithSubtitleUrl" class="portal-logo" />
        </div>
      </section>
      <section class="col-lg-7 col-md-6 col-xxs-12 d-xxs-none d-md-block justify-content-center align-items-center">
        <RegsiterFormCollection :products="this.products" />
      </section>
    </article>
    <div class="circles d-flex align-self-end justify-content-end">
      <div class="circle red" />
      <div class="circle yellow" />
      <div class="circle green" />
    </div>
  </main>
</template>

<script>
import RegisterForm from '@/components/RegisterForm.vue'
import RegsiterFormCollection from '@/components/RegsiterFormCollection.vue'
import RegisterByGoogle from '@/components/RegisterByGoogle.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Register',
  components: {
    RegisterForm,
    RegsiterFormCollection,
    RegisterByGoogle
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config',
      featuredCollectionId: 'tenantDesign/featuredCollectionId',
      collection: 'productCatalog/collection'
    }),
    products () {
      let collection = this.collection(this.featuredCollectionId)
      if (collection && collection.products) {
        return collection.products
      } else {
        return []
      }
    },
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  },
  methods: {
    ...mapActions({
      loadCollectionProduct: 'productCatalog/loadCollectionProducts',
      loadCollection: 'productCatalog/loadCollection'
    })
  },
  mounted () {
    let collection = this.collection(this.featuredCollectionId)
    if (!collection) {
      this.loadCollection(this.featuredCollectionId)
    } else if (!collection.products) { this.loadCollectionProduct(this.featuredCollectionId) }
  }
}
</script>
